<template>
  <v-container class="fluid-max-width pa-0">
    <v-breadcrumbs :items="breadcrumbItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-container>
      <h1 v-if="user" class="mb-6 primary--text">{{ user.company.name }}</h1>
      <FormAddSite :user="user" @submit="$router.back()" />
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FormAddSite from '@/components/FormAddSite.vue';

export default {
  name: 'AddSite',
  components: { FormAddSite },
  data: () => ({
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Baustellen',
        disabled: false,
        to: '/baustellen/',
      },
      {
        text: 'Baustelle hinzufügen',
        disabled: true,
        to: '/add',
      },
    ],
  }),
  computed: {
    ...mapGetters(['user']),
  },
  async created() {
    await this.autoLogin();
  },
  methods: {
    ...mapActions(['autoLogin', 'getUser']),
  },
};
</script>

<style scoped></style>
